import { Component, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { each, find, forEach, get } from 'lodash';
import { PlatformChoiceService } from './platform.choice.service';
import { REMOVED } from '../../services/base.wizard.step';
import { LabelsService } from '@nrwl/common-lib';

@Component({
  selector: 'platform-choice',
  templateUrl: './platform.choice.template.html',
  styleUrls: ['./platform.choice.style.scss']
})
export class PlatformChoiceComponent implements OnChanges {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() parentOutput: any; // <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any; //<
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix,@typescript-eslint/no-explicit-any
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();
  @Input() key: string; //@
  isVirtualAgentSelected = false;
  loadAttempt = 0; // 0 - not yet, 1 - in progress, 2 - done (either OK or failure)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  platformList: any = [];

  //Should be remove once the agentmanager backend service available with PTC
  platformListConst: string[] = ['QCOW2', 'OVA', 'VMDK'];

  constructor(
    private platformChoiceService: PlatformChoiceService,
    private labelService: LabelsService
  ) {}

  mustBePresented(): boolean {
    return this.isVirtualAgentSelected;
  }

  _populateList(platformOptions = []): void {
    forEach(platformOptions, platform => {
      // CSB-4804 for revealed v1.1 we do not officially support VMDK - skip for now
      if (platform !== 'VMDK') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = { internalValue: platform, label: platform };
        const labelInfo = this.labelService.getLabel(platform);

        if (labelInfo) {
          if (labelInfo.description) {
            data.description = labelInfo.description;
          }
          if (labelInfo.helpLink) {
            data.helpLink = labelInfo.helpLink;
          }
          // backend does not tell which of platforms should be 'preferred'. so we pick it ourselves
          if (labelInfo.default) {
            data.selected = true;
          }
        }
        this.platformList.push(data);
      }
    });
  }

  _recalculateSelectionState(): void {
    // restore 'selection' if user clicked 'Back' to revisit the page
    if (this.parentOutput) {
      const knownChoice = this.parentOutput[this.key];
      if (knownChoice && knownChoice !== REMOVED) {
        forEach(this.platformList, element => {
          element.selected = knownChoice && element.internalValue === knownChoice;
        });
      }
    }
  }

  /**
   * Please note this event is triggered only for one-way bindings (<)
   */

  ngOnChanges() {
    const agentType = get(this.step, 'output.agentType.id', '');

    this.isVirtualAgentSelected = agentType === 'virtual';
    this._populateList(this.platformListConst);
    this._recalculateSelectionState();
    this.onUpdate.emit({ key: this.key, value: this._makeOutput() });
    /*if (this.loadAttempt === 0) {
      this.loadAttempt = 1;
      this.platformChoiceService.loadPlatformOptions((response) => {
        this.loadAttempt = 2;
        // occassionaly, backend will not fulfill our request. check for this
        if (response && response.data) {
          this._populateList(response.data.success);
          this._recalculateSelectionState();
        }
        this.onUpdate.emit({key: this.key, value : this._makeOutput()});
      });
    }*/
  }

  // eslint-disable-next-line
  _onClick(platform: any): void {
    each(this.platformList, element => {
      element.selected = element === platform;
    });
    this.onUpdate.emit({ key: this.key, value: this._makeOutput() });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _makeOutput(): any {
    if (!this.isVirtualAgentSelected) {
      // if agent type has changed, request removal of platform value
      return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedPlatform: any = find(this.platformList, { selected: true });
    if (selectedPlatform) {
      return selectedPlatform.internalValue;
    }
    return null;
  }
}
